import { render } from "./CreateUser.vue?vue&type=template&id=aca2caf6&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=aca2caf6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aca2caf6"]])

export default __exports__